import ConfigManagerPage from "./ConfigManagerPage";

const RecommendationConfigManagerPage = () => (
  <ConfigManagerPage title="推薦ロジック管理" configGroup="recommendation" />
);

export default RecommendationConfigManagerPage;
